import { render } from "./ModalUsersAccessType.vue?vue&type=template&id=54f4625a"
import script from "./ModalUsersAccessType.vue?vue&type=script&lang=js"
export * from "./ModalUsersAccessType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__